// extracted by css-extract-rspack-plugin
export default {"mutedText":"ResolvedPlanApproval-module__mutedText__ySg_H","feedbackBubble":"ResolvedPlanApproval-module__feedbackBubble__AZt8C"};